import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { InitialLoadingBlock } from '@/components/common/initial-loading-block'
import BasicInfoForm from '@/components/kol/common/kol-cooperation-detail-drawer/contact-info/basic-info-form'
import ContactInfoForm from '@/components/kol/common/kol-cooperation-detail-drawer/contact-info/contact-info-form'
import { useKolContactInfo } from '@/components/kol/common/kol-cooperation-detail-drawer/contact-info/use-kol-contact-info'

interface ContactInfoProps {
  kolId: string
}

const ContactInfo: FunctionComponent<ContactInfoProps> = ({ kolId }) => {
  const data = useKolContactInfo(kolId)

  if (data.isLoading) {
    return <InitialLoadingBlock />
  }

  return (
    <Wrapper>
      <BasicInfoForm
        isFetching={data.isFetchingBasicInfo}
        kolId={kolId}
        responseData={data.basicInfo}
      />
      <ContactInfoForm
        isFetching={data.isFetchingContactInfo}
        kolId={kolId}
        responseData={data.contactInfos}
      />
    </Wrapper>
  )
}

export default ContactInfo

const Wrapper = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`
